import React, { useState } from 'react';
import { FormComponent } from '../../../../shared';
import {
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
    Typography,
    makeStyles,
    Paper,
    FormControl,
} from '@material-ui/core';
import { SourceSelector } from './SourceSelector';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
    },
    formControl: {
        minWidth: 200,
    },
    filterSection: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.borderRadius,
        width: '60%',
    },
    filtersContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.spacing(2),
        flexWrap: 'wrap',
        flex: 1,
    },
    dateGroup: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    timeframeLabel: {
        whiteSpace: 'nowrap',
    },
    okButton: {
        marginLeft: theme.spacing(2),
    },
}));

const LocationAccuracyRangeAndSourceSelection = ({ onSubmit, initialStartDate, initialEndDate }) => {
    const classes = useStyles();
    const [selectedSource, setSelectedSource] = useState('ALL');
    const [showIncomplete, setShowIncomplete] = useState(false);
    const [excludeReplenishment, setExcludeReplenishment] = useState(false);

    const handleShowIncompleteChange = (event) => {
        setShowIncomplete(event.target.checked);
    };

    const handleSourceChange = (event) => {
        setSelectedSource(event.target.value);
    };

    const handleExcludeReplenishmentChange = (event) => {
        setExcludeReplenishment(event.target.checked);
    };

    const handleSubmit = async (formData) => {
        if (selectedSource && selectedSource !== 'ALL') {
            formData.selectedSource = selectedSource;
        } else {
            formData.selectedSource = null;
        }
        formData.showIncomplete = showIncomplete;
        formData.excludeReplenishment = excludeReplenishment;
        await onSubmit(formData);
    };

    const formFields = [
        {
            name: 'start',
            inputElement: 'date',
            initialValue: initialStartDate,
            gridValue: 5,
            inputProps: {
                required: true,
                size: 'small',
            },
        },
        {
            name: 'end',
            inputElement: 'date',
            initialValue: initialEndDate,
            gridValue: 5,
            inputProps: {
                required: true,
                size: 'small',
            },
        },
    ];

    const formButton = {
        text: 'OK',
        gridValue: 2,
        variant: 'contained',
        color: 'primary',
        className: classes.okButton,
    };

    return (
        <Paper className={classes.root}>
            <div className={classes.filterSection}>
                <div className={classes.filtersContainer}>
                    <div className={classes.filterGroup}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="includeIncomplete"
                                    value={showIncomplete}
                                    onChange={handleShowIncompleteChange}
                                    color="primary"
                                />
                            }
                            label="Show Incomplete"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="excludeReplenishment"
                                    checked={excludeReplenishment}
                                    onChange={handleExcludeReplenishmentChange}
                                    color="primary"
                                />
                            }
                            label="Exclude Replenishment"
                        />
                        <SourceSelector
                            value={selectedSource}
                            onChange={handleSourceChange}
                            className={classes.formControl}
                        />
                    </div>

                    <div className={classes.dateGroup}>
                        <Typography variant="subtitle1" className={classes.timeframeLabel}>
                            Timeframe:
                        </Typography>
                        <FormComponent formFields={formFields} button={formButton} onSubmit={handleSubmit} />
                    </div>
                </div>
            </div>
        </Paper>
    );
};

export { LocationAccuracyRangeAndSourceSelection };
